import { Link } from "react-router";

import { ClaimCard } from "@/components/ClaimCard";
import { PageHeader } from "@/components/ui";
import { NETWORK_NAME } from "@/lib/config";
import { usePageMeta } from "@/lib/page-meta";

export function ClaimPage() {
  usePageMeta({
    title: "Migrasi AsetQu Legacy",
    description: "Migrasikan AsetQu Legacy melalui dua transaksi yang dapat direview dan diverifikasi.",
  });

  return (
    <div className="page-shell page-shell--transaction">
      <PageHeader
        context={`Official migration / ${NETWORK_NAME}`}
        title="MIGRASIKAN ASETQU LEGACY"
        description="Satu keputusan per tahap. Periksa wallet, jumlah, network, dan kontrak penuh sebelum setiap tanda tangan."
        meta={
          <>
            <span>Rasio <strong>1 : 1</strong></span>
            <span>Exact approval</span>
            <span>Dua tanda tangan</span>
          </>
        }
      />

      <ClaimCard />

      <section className="transaction-notes" aria-labelledby="transaction-notes-title">
        <div>
          <p>MODEL DUA TANDA TANGAN</p>
          <h2 id="transaction-notes-title">Izin token bukan perpindahan token.</h2>
        </div>
        <dl>
          <div>
            <dt>01 / PERMISSION</dt>
            <dd>
              Memberi kontrak migrasi izin menggunakan jumlah AsetQu Legacy yang Anda pilih.
              Tidak ada token yang berpindah pada tahap ini.
            </dd>
          </div>
          <div>
            <dt>02 / MIGRATION</dt>
            <dd>
              Memindahkan AsetQu Legacy melalui kontrak resmi dan mengirim AsetQu baru ke wallet
              yang sama dengan rasio 1:1.
            </dd>
          </div>
        </dl>
        <p>
          Butuh pembanding alamat? Buka <Link to="/contract-addresses">daftar kontrak resmi</Link>
          {" "}atau baca <Link to="/security">aturan keamanan</Link> sebelum melanjutkan.
        </p>
      </section>
    </div>
  );
}
